module.exports = __webpack_public_path__ + "static/media/email.05dee59c.png";